var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0uc29omnha)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.513 3.513a12.001 12.001 0 1 1 16.972 16.972A12.001 12.001 0 0 1 3.513 3.513zm17.37 13.078a10 10 0 1 0-17.44.587 7.6 7.6 0 0 1 3.11-1.57 5.034 5.034 0 1 1 6.749-5.51c.02.08.032.161.033.242a5.034 5.034 0 0 1-3.223 5.268 7.601 7.601 0 0 1 3.265 1.704 5.397 5.397 0 0 1 1.89-1.43 3.558 3.558 0 0 1-1.063-1.418 3.566 3.566 0 1 1 5.527 1.418l.006.002c.412.188.797.426 1.147.707zm-6.176 2.267a3.398 3.398 0 0 1 5.075-.579 10 10 0 0 1-4.047 2.997 7.6 7.6 0 0 0-1.028-2.418zm-2.005.636a.98.98 0 0 0 .075.096 5.6 5.6 0 0 1 1.034 2.245 10 10 0 0 1-9.163-3.055 5.6 5.6 0 0 1 8.054.714zm-1.577-9.78a3.032 3.032 0 0 0-4.908-.99 5.7 5.7 0 0 0 4.908.99zm-5.806.829a3.033 3.033 0 0 0 5.928 1.196 7.7 7.7 0 0 1-5.928-1.196zm12.18.99a1.568 1.568 0 1 0 0 3.135 1.568 1.568 0 0 0 0-3.136z",
    fill: "#8A8DAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0uc29omnha"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.4baeee31c879e53ef80e60cebfa43eb0.svg";
export { ForwardRef as ReactComponent };